import React from 'react';

import TechnicalSpecs from '../components/TechnicalSpecs';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';
import { useLanguage } from '../contexts/LanguageContext';

const TechnicalPage: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark">

         <PageHeader 
        title={t('specs.title', 'Technical Specifications')}
        subtitle={t('specs.description', 'Detailed analysis of our vermicompost parameters, quality standards, and scientific certification.')}
        backgroundImage="https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" // Lab/scientific image
      />

      <div className=" pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          {/* <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-extrabold mb-6 text-emerald-900 dark:text-white">
              Technical Specifications
            </h1>
            <p className="text-xl text-emerald-800/70 dark:text-emerald-100/60 max-w-3xl mx-auto">
              Detailed analysis of our vermicompost parameters, quality standards, and scientific certification.
            </p>
          </div> */}
          <TechnicalSpecs />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TechnicalPage;